import React, { useRef, useState } from 'react';
import logo from "./logo.png";

const staticEmployee = {
  profileImg: null,
  profileInitials: 'VD',
  employeeId: '7648',
  name: 'Venkatesh Dev',
  mobile: '9848316655',
  email: 'venkynama15@gmail.com',
  department: 'Development',
  designation: 'Developer',
  branch: 'Main',
  rfid: '45455',
};

const fakeApiSave = (endpoint, payload) => {
  console.info('Fake API call ->', endpoint, payload);
  return new Promise((resolve) => setTimeout(() => resolve({ ok: true, data: payload }), 700));
};

export default function EmployeeProfileWithJobForm() {
  const [step, setStep] = useState(1);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const contentRef = useRef(null);

  const [contact, setContact] = useState({
    email: staticEmployee.email,
    contact1: '',
    contact2: '',
    currentAddress: '',
    permanentAddress: '',
  });

  const [bank, setBank] = useState({
    accountNo: '42345667383',
    accountHolder: 'Sujatha',
    bank: 'ICIC',
    branch: 'Hyderabad',
    ifsc: 'ICIC232',
  });

  const [proofs, setProofs] = useState({
    pan: '',
    panFile: null,
    aadhar: '',
    aadharFile: null,
    voterId: '',
    voterFile: null,
    pf: '',
    epfStart: '',
    uan: '',
  });

  const [family, setFamily] = useState([
    { name: 'Suresh Kumar', dob: '2023-03-09', relation: 'Brother', age: '33' }
  ]);
 console.log(setFamily);

  const stepsMeta = [
    { id: 1, key: 'Contact', label: 'Personal ' },
    { id: 2, key: 'Bank', label: 'Bank ' },
    { id: 3, key: 'Proofs', label: 'Proofs' },
    { id: 4, key: 'Family', label: 'Family ' },
  ];
  const iconsMap = {
    Contact: 'bi-person-fill',
    Bank: 'bi-credit-card-2-back-fill',
    Proofs: 'bi-person-vcard',
    Family: 'bi-people-fill',
  };

  const validateStep = (s) => {
    const e = {};
    if (s === 1) {
      if (!contact.email.trim()) e.email = 'Email is required';
      else if (!/\S+@\S+\.\S+/.test(contact.email)) e.email = 'Invalid email';
    }
    if (s === 2) {
      if (!bank.accountNo.trim()) e.accountNo = 'Account number required';
      if (!bank.accountHolder.trim()) e.accountHolder = 'Account holder required';
      if (!bank.ifsc.trim()) e.ifsc = 'IFSC code required';
    }
    if (s === 3) {
      if (!proofs.pan.trim()) e.pan = 'PAN required';
      if (!proofs.aadhar.trim()) e.aadhar = 'Aadhar required';
    }
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleNext = async () => {
    if (!validateStep(step)) return;
    setSaving(true);
    try {
      let payload = {};
      let endpoint = '';
      if (step === 1) { payload = contact; endpoint = '/api/save/contact'; }
      if (step === 2) { payload = bank; endpoint = '/api/save/bank'; }
      if (step === 3) { payload = proofs; endpoint = '/api/save/proofs'; }
      if (step === 4) { payload = family; endpoint = '/api/save/family'; }

      if (endpoint) await fakeApiSave(endpoint, payload);

      setSaving(false);
      setStep((p) => Math.min(8, p + 1));
      setErrors({});
      contentRef.current?.scrollIntoView({ behavior: 'smooth' });
    } catch (err) {
      setSaving(false);
      alert('Save failed (dummy).');
    }
  };

  const handlePrevious = () => {
    setErrors({});
    setStep((p) => Math.max(1, p - 1));
    contentRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSubmit = async () => {
    setSaving(true);
    try {
      const payload = { contact, bank, proofs, family };
      await fakeApiSave('/api/submit/all', payload);
      setSaving(false);
      alert('All details submitted successfully (dummy).');
    } catch (err) {
      setSaving(false);
      alert('Submit failed (dummy).');
    }
  };

  const progress = Math.round(((step - 1) / (stepsMeta.length - 1)) * 100);

  const handleFileChange = () => {
    // setFiles(prev => ({ ...prev, [field]: file }));
    //  console.log(setFiles);
  };
 
  const showHeader = step === 1;

  return (
    <div className="container py-3" ref={contentRef}>
      <style>{`
        .profile-card { border-radius: 12px; box-shadow: 0 6px 20px rgba(0,0,0,0.08); overflow: hidden; }
        .cover { height: 110px; background: linear-gradient(90deg,#e0e7ff,#f3f4f6); display:flex; align-items:center; justify-content:flex-end; padding:12px; }
        .logo-sm { height:48px; opacity:0.95; }
        .avatar-circle { width:100px; height:100px; border-radius:50%; border:5px solid white; display:flex; align-items:center; justify-content:center; background:#e0e7ff; font-size:2.2rem; color:#6366f1; margin-top:-50px; }
        .profile-name { font-weight:700; font-size:1.2rem; }
        .profile-sub { color:#6b7280; font-size:0.95rem; }
        .steps-row {
          display: flex; justify-content: space-between; align-items: center;
          gap: 10px; padding: 16px 0; overflow-x: auto;
          scrollbar-width: none; -ms-overflow-style: none;
        }
        .steps-row::-webkit-scrollbar { display: none; }
        .step-item { min-width:80px; text-align:center; flex:1; }
        .step-icon { width:50px; height:50px; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; font-size:1.1rem; margin-bottom:6px; transition:all 0.3s; }
        .step-label { font-size:0.78rem; font-weight:600; color:#374151; }
        .step-muted { font-size:0.7rem; color:#9ca3af; }
        .progress-small { height:6px; border-radius:999px; background:#e5e7eb; }
        .progress-fill { height:100%; background:linear-gradient(90deg,#6366f1,#4f46e5); border-radius:999px; transition: width 0.4s ease; }
        .form-card { border-radius:12px; box-shadow: 0 4px 16px rgba(0,0,0,0.05); padding:18px; background:#fff; }
        .form-title { font-weight:700; font-size:1.1rem; color:#1f2937; }
        .form-label { font-size:0.875rem; font-weight:500; }
        .form-control.invalid, .form-select.invalid { border-color:#ef4444; }
        .error-text { color:#ef4444; font-size:0.8rem; margin-top:4px; }
        .btn-primary-custom { background: linear-gradient(90deg,#6366f1,#4f46e5); border: none; font-weight:500; }
        .file-upload { border:2px dashed #d1d5db; border-radius:8px; padding:12px; text-align:center; background:#f9fafb; }
        .file-preview { max-width:100%; max-height:80px; margin-top:8px; border-radius:6px; }
        .section-title { font-size:0.95rem; font-weight:600; color:#374151; margin-bottom:8px; }
        .info-row { display:flex; justify-content:space-between; padding:6px 0; border-bottom:1px solid #f3f4f6; font-size:0.9rem; }
        .info-label { color:#6b7280; }
        .info-value { color:#1f2937; font-weight:500; }
        @media (max-width: 576px) {
          .cover { height:90px; }
          .logo-sm { height:36px; }
          .avatar-circle { width:80px; height:80px; margin-top:-40px; font-size:1.8rem; }
          .step-icon { width:42px; height:42px; font-size:0.95rem; }
          .step-label { font-size:0.7rem; }
          .steps-row { gap:6px; padding:12px 0; }
          .form-card { padding:14px; }
          .form-title { font-size:1rem; }
        }
        @media (min-width: 768px) {
          .cover { height:140px; }
          .logo-sm { height:56px; }
          .avatar-circle { width:110px; height:110px; margin-top:-55px; }
        }

        /* hide header after step 1 */
        .header-hidden { display: none; }
      `}</style>

      {/* ---------- PROFILE HEADER (shown only on step 1) ---------- */}
      {showHeader && (
        <div className="profile-card mb-4">
          <div className="cover">
            <img src={logo} alt="logo" className="logo-sm" onError={(e) => (e.target.style.display = 'none')} />
          </div>
          <div className="px-3 pb-3">
            <div className="d-flex justify-content-between align-items-start">
              <div className="d-flex align-items-start">
                <div className="avatar-circle me-3">
                  {staticEmployee.profileImg ? (
                    <img src={staticEmployee.profileImg} alt="profile" style={{ width: '100%', height: '100%', borderRadius: '50%' }} />
                  ) : staticEmployee.profileInitials}
                </div>
                <div>
                  <div className="profile-name">{staticEmployee.name}</div>
                  <div className="profile-sub">{staticEmployee.designation} | {staticEmployee.department}</div>
                </div>
              </div>

              <div className="text-end d-none d-sm-block">
                <div className="profile-sub">Employee ID: <strong>{staticEmployee.employeeId}</strong></div>
                <div className="profile-sub">Biometric ID: <strong>{staticEmployee.rfid}</strong></div>
              </div>
            </div>

            <div className="d-block d-sm-none mt-3">
              <div className="d-flex justify-content-between profile-sub small">
                <span>Employee ID: <strong>{staticEmployee.employeeId}</strong></span>
                <span>Biometric ID: <strong>{staticEmployee.rfid}</strong></span>
              </div>
            </div>

            <div className="mt-3 d-flex gap-2 flex-wrap profile-sub">
              <a href={`mailto:${staticEmployee.email}`}>{staticEmployee.email}</a> |
              +91 {staticEmployee.mobile}
            </div>
          </div>
        </div>
      )}

      <div className="mb-4">
        <div className="steps-row">
          {stepsMeta.map((s) => {
            const active = s.id === step;
            const done = s.id < step;
            const iconClass = iconsMap[s.key] || 'bi-person-fill';

            return (
              <div className="step-item" key={s.id}>
                <div
                  className="step-icon mx-auto"
                  style={{
                    background: done ? '#6366f1' : active ? 'linear-gradient(90deg,#6366f1,#4f46e5)' : '#e5e7eb',
                    color: done || active ? '#fff' : '#6b7280',
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.3rem',
                    transition: 'all 0.3s ease',
                  }}
                >
                  {done ? (
                    <i className="bi bi-check-lg" style={{ fontSize: '1.5rem' }}></i>
                  ) : (
                    <i className={iconClass}></i>
                  )}
                </div>
                <div className="step-label">{s.label}</div>
                <div className="step-muted">{s.id <= step ? 'Done' : 'Pending'}</div>
              </div>
            );
          })}
        </div>

        <div className="progress-small mt-2">
          <div
            className="progress-fill"
            style={{
              width: `${progress}%`,
              background: 'linear-gradient(90deg,#6366f1,#4f46e5)',
              height: '6px',
              borderRadius: '999px',
              transition: 'width 0.4s ease',
            }}
          />
        </div>
      </div>

      <div className="form-card">
        {step === 1 && (
          <div>
            <div className="mb-3">
              <div className="form-title">Personal Details</div>
              <div className="text-muted small">Update your contact and address details.</div>
            </div>
            <div className="row g-3">
              <div className="col-12">
                <label className="form-label">Email <span className="text-danger">*</span></label>
                <input type="email" className={`form-control ${errors.email ? 'invalid' : ''}`} value={contact.email} onChange={(e) => setContact({ ...contact, email: e.target.value })} />
                {errors.email && <div className="error-text">{errors.email}</div>}
              </div>
              <div className="col-12 col-md-6">
                <label className="form-label">Mobile No</label>
                <input type="tel" className="form-control" value={contact.contact1} onChange={(e) => setContact({ ...contact, contact1: e.target.value })} />
              </div>
              <div className="col-12">
                <label className="form-label">Current Address</label>
                <textarea className="form-control" rows={2} value={contact.currentAddress} onChange={(e) => setContact({ ...contact, currentAddress: e.target.value })} />
              </div>
              <div className="col-12">
                <label className="form-label">Permanent Address</label>
                <textarea className="form-control" rows={2} value={contact.permanentAddress} onChange={(e) => setContact({ ...contact, permanentAddress: e.target.value })} />
              </div>
            </div>
          </div>
        )}

        {step === 2 && (
          <div>
            <div className="mb-3">
              <div className="form-title">Bank Details</div>
            </div>
            <div className="row g-3">
              <div className="col-12 col-md-6">
                <label className="form-label">Account No <span className="text-danger">*</span></label>
                <input type="text" className={`form-control ${errors.accountNo ? 'invalid' : ''}`} value={bank.accountNo} onChange={(e) => setBank({ ...bank, accountNo: e.target.value })} />
                {errors.accountNo && <div className="error-text">{errors.accountNo}</div>}
              </div>
              <div className="col-12 col-md-6">
                <label className="form-label">Account Holder <span className="text-danger">*</span></label>
                <input type="text" className={`form-control ${errors.accountHolder ? 'invalid' : ''}`} value={bank.accountHolder} onChange={(e) => setBank({ ...bank, accountHolder: e.target.value })} />
                {errors.accountHolder && <div className="error-text">{errors.accountHolder}</div>}
              </div>
              <div className="col-12 col-md-6">
                <label className="form-label">Bank</label>
                <input type="text" className="form-control" value={bank.bank} onChange={(e) => setBank({ ...bank, bank: e.target.value })} />
              </div>
              <div className="col-12 col-md-6">
                <label className="form-label">Branch</label>
                <input type="text" className="form-control" value={bank.branch} onChange={(e) => setBank({ ...bank, branch: e.target.value })} />
              </div>
              <div className="col-12">
                <label className="form-label">IFSC Code <span className="text-danger">*</span></label>
                <input type="text" className={`form-control ${errors.ifsc ? 'invalid' : ''}`} value={bank.ifsc} onChange={(e) => setBank({ ...bank, ifsc: e.target.value })} />
                {errors.ifsc && <div className="error-text">{errors.ifsc}</div>}
              </div>
            </div>
          </div>
        )}

        {step === 3 && (
          <div>
            <div className="mb-3">
              <div className="form-title">Employee Proofs</div>
            </div>

            <div className="row g-3">
              <div className="col-12 col-md-6">
                <label className="form-label">
                  PAN <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.pan ? "invalid" : ""}`}
                  value={proofs.pan}
                  onChange={(e) => setProofs({ ...proofs, pan: e.target.value })}
                />
                {errors.pan && <div className="error-text">{errors.pan}</div>}
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">
                  Aadhar <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  maxLength={12}
                  className={`form-control ${errors.aadhar ? "invalid" : ""}`}
                  value={proofs.aadhar}
                  onChange={(e) => setProofs({ ...proofs, aadhar: e.target.value })}
                />
                {errors.aadhar && <div className="error-text">{errors.aadhar}</div>}
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">Voter ID</label>
                <input
                  type="text"
                  className="form-control"
                  value={proofs.voterId}
                  onChange={(e) => setProofs({ ...proofs, voterId: e.target.value })}
                />
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">Upload PAN</label>
                <input
                  type="file"
                  accept="image/png, image/jpeg"
                  className="form-control"
                  onChange={(e) => handleFileChange("panFile", e.target.files[0])}
                />
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">Upload Aadhar</label>
                <input
                  type="file"
                  accept="image/png, image/jpeg"
                  className="form-control"
                  onChange={(e) => handleFileChange("aadharFile", e.target.files[0])}
                />
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">Upload Voter</label>
                <input
                  type="file"
                  accept="image/png, image/jpeg"
                  className="form-control"
                  onChange={(e) => handleFileChange("voterFile", e.target.files[0])}
                />
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">PF</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter PF no"
                  value={proofs.pf}
                  onChange={(e) => setProofs({ ...proofs, pf: e.target.value })}
                />
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">EPF Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={proofs.epfStart}
                  onChange={(e) => setProofs({ ...proofs, epfStart: e.target.value })}
                />
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">UAN</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter UAN no"
                  value={proofs.uan}
                  onChange={(e) => setProofs({ ...proofs, uan: e.target.value })}
                />
              </div>
            </div>
          </div>
        )}

        {/* Step 4: Family Details */}
        {step === 4 && (
          <div>
            <div className="mb-3">
              <div className="form-title">Family Details</div>
            </div>
            {family.map((member, i) => (
              <div key={i} className="border p-3 rounded mb-3">
                <div className="row g-3">
                  <div className="col-12 col-md-6">
                    <label className="form-label">Member Name</label>
                    <input type="text" className="form-control" value={member.name} readOnly />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="form-label">Relation</label>
                    <input type="text" className="form-control" value={member.relation} readOnly />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="form-label">Age</label>
                    <input type="text" className="form-control" value={member.age} readOnly />
                  </div>
                </div>
              </div>
            ))}
            <button className="btn btn-outline-primary btn-sm">+ Add Member</button>
          </div>
        )}
        {/* Navigation Buttons */}
        <div className="d-flex justify-content-between align-items-center mt-4">
          <button className="btn btn-outline-secondary px-4" onClick={handlePrevious} disabled={step === 1 || saving}>
            Previous
          </button>
          {step < 8 ? (
            <button className="btn btn-primary btn-primary-custom px-4" onClick={handleNext} disabled={saving}>
              {saving ? 'Saving...' : 'Next'}
            </button>
          ) : (
            <button className="btn btn-success px-5" onClick={handleSubmit} disabled={saving}>
              {saving ? 'Submitting...' : 'Submit All'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}